import { render, staticRenderFns } from "./SOASupplement.vue?vue&type=template&id=5a6f5b8e&"
import script from "./SOASupplement.vue?vue&type=script&lang=js&"
export * from "./SOASupplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports